import { AsyncAspect, SyncAspect } from '@tencent/memoire-plugable';
function createAspectStats() {
    return {
        timings: new Map(),
        counters: new Map(),
        messages: new Map(),
        errors: new Map(),
        flags: new Map(),
        data: new Map(),
    };
}
export function createStorageAspects() {
    return {
        collection: {
            get: AsyncAspect.withContext(createAspectStats),
            has: AsyncAspect.withContext(createAspectStats),
            delete: AsyncAspect.withContext(createAspectStats),
            insert: AsyncAspect.withContext(createAspectStats),
            upsert: AsyncAspect.withContext(createAspectStats),
            bulkInsert: AsyncAspect.withContext(createAspectStats),
            bulkUpsert: AsyncAspect.withContext(createAspectStats),
            update: AsyncAspect.withContext(createAspectStats),
            clear: AsyncAspect.withContext(createAspectStats),
            count: AsyncAspect.withContext(createAspectStats),
            entries: AsyncAspect.withContext(createAspectStats),
            keys: AsyncAspect.withContext(createAspectStats),
            values: AsyncAspect.withContext(createAspectStats),
            first: AsyncAspect.withContext(createAspectStats),
            last: AsyncAspect.withContext(createAspectStats),
            skip: SyncAspect.withContext(createAspectStats),
            take: SyncAspect.withContext(createAspectStats),
            slice: SyncAspect.withContext(createAspectStats),
            orderBy: SyncAspect.withContext(createAspectStats),
            where: SyncAspect.withContext(createAspectStats),
            or: SyncAspect.withContext(createAspectStats),
        },
        query: {},
        model: {},
        migration: {
            prepareAutoUpgradeHandler: AsyncAspect.withContext(createAspectStats),
            buildMigration: SyncAspect.withContext(createAspectStats),
            executeDataMigration: AsyncAspect.withContext(createAspectStats),
            executeSchemaMigration: SyncAspect.withContext(createAspectStats),
            updateMigrationChangeInfo: AsyncAspect.withContext(createAspectStats),
            log: SyncAspect.withContext(createAspectStats),
            actionExecutor: {
                executeSchemaAction: SyncAspect.withContext(createAspectStats),
                executeDataAction: AsyncAspect.withContext(createAspectStats),
            },
        },
        engine: {
            deleteDB: AsyncAspect.withContext(createAspectStats),
            openDB: AsyncAspect.withContext(createAspectStats),
            database: {
                createTable: SyncAspect.withContext(createAspectStats),
                deleteTable: SyncAspect.withContext(createAspectStats),
                close: SyncAspect.withContext(createAspectStats),
                table: AsyncAspect.withContext(createAspectStats),
                transaction: AsyncAspect.withContext(createAspectStats),
            },
            table: {
                createIndex: AsyncAspect.withContext(createAspectStats),
                deleteIndex: AsyncAspect.withContext(createAspectStats),
                delete: AsyncAspect.withContext(createAspectStats),
                get: AsyncAspect.withContext(createAspectStats),
                getAll: AsyncAspect.withContext(createAspectStats),
                getAllKeys: AsyncAspect.withContext(createAspectStats),
                index: SyncAspect.withContext(createAspectStats),
                insert: AsyncAspect.withContext(createAspectStats),
                query: AsyncAspect.withContext(createAspectStats),
                openCursor: AsyncAspect.withContext(createAspectStats),
                upsert: AsyncAspect.withContext(createAspectStats),
                bulkUpsert: AsyncAspect.withContext(createAspectStats),
                clear: AsyncAspect.withContext(createAspectStats),
                bulkDelete: AsyncAspect.withContext(createAspectStats),
            },
            index: {
                get: AsyncAspect.withContext(createAspectStats),
                getAll: AsyncAspect.withContext(createAspectStats),
                getAllKeys: AsyncAspect.withContext(createAspectStats),
                openCursor: AsyncAspect.withContext(createAspectStats),
            },
            cursor: {
                delete: AsyncAspect.withContext(createAspectStats),
                update: AsyncAspect.withContext(createAspectStats),
                next: AsyncAspect.withContext(createAspectStats),
                value: SyncAspect.withContext(createAspectStats),
            },
            transaction: {
                commit: AsyncAspect.withContext(createAspectStats),
                rollback: AsyncAspect.withContext(createAspectStats),
                table: SyncAspect.withContext(createAspectStats),
            },
        },
    };
}
//# sourceMappingURL=aspects.js.map